<template>
    <div class="header">
        <NavBar />
    </div>
</template>

<script>
import NavBar from './NavBar';

export default {
    name: 'Header',
    components: {
        NavBar
    }
}
</script>

<style lang="sass" scope>
    @import '../assets/styles/_app.sass';
</style>